export const lazyInitializedEventName = "lmz_lazy_initialized";
const localStorageKey = "lmx_lazy_init";
let innerLazyPromise: Promise<void> = new Promise(() => {});

type ResolveCallbackType = (value: void | PromiseLike<void>) => void;

export function initLazyEvent() {
    const events = ["scroll", "click", "keydown", "tap", "mousemove"];
    let resolveCallback: null | ResolveCallbackType = null;
    innerLazyPromise = new Promise((resolve: ResolveCallbackType) => {
        resolveCallback = resolve;
    });

    const dispatch = () => {
        localStorage.setItem(localStorageKey, "1");
        document.dispatchEvent(new Event(lazyInitializedEventName));
        if (resolveCallback) {
            resolveCallback();
        }
    };

    const removeListeners = () => {
        events.forEach((e) => removeEventListener(e, startLoading));
    };

    const startLoading = () => {
        removeListeners();
        dispatch();
    };

    if (lazyIsLoaded()) {
        dispatch();
    } else {
        events.forEach((e) => addEventListener(e, startLoading));
    }
}

export function lazyIsLoaded() {
    return localStorage.getItem(localStorageKey);
}

export async function lazyFunction(callback: ResolveCallbackType) {
    await lazyPromise();
    callback();
}

type ElementsCallbackFunction = (elements?: NodeListOf<Element>) => void;

export function elementExistFunction(
    selector: string,
    callback: ElementsCallbackFunction,
) {
    const elms = document.querySelectorAll(selector);
    if (elms.length > 0) {
        callback(elms);
    }
}

export function elementsExistFunction(
    selectors: Array<string>,
    callback: () => void,
) {
    if (doElementsExists(selectors)) {
        callback();
    }
}

function doElementsExists(selectors: Array<string>) {
    for (const selector of selectors) {
        const elms = document.querySelectorAll(selector);
        if (elms.length > 0) {
            return true;
        }
    }

    return false;
}

export async function elementExistLazyFunction(
    selector: string,
    callback: ElementsCallbackFunction,
) {
    await lazyPromise();
    elementExistFunction(selector, callback);
}

export function lazyPromise(): Promise<void> {
    return innerLazyPromise;
}
